// extracted by mini-css-extract-plugin
module.exports = {"root":"_2GhDN","bg":"_2jfia","top":"_3P4tz","bot":"Bm3U3"};